module.exports = __webpack_public_path__ + "static/media/LSP-Pressure.17c5d097.svg";